// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Message } from './message';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class MessageAttachment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get url() {
        return `https://peccerium.blob.core.windows.net/neland/MessageAttachments/${this.fileName}`;
    }
    get urlGraafschap() {
        return `https://peccerium.blob.core.windows.net/graafschap/MessageAttachments/${this.fileName}`;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  content?: any;
  contentType?: string;
  fileName?: string;
  messageId!: string;
  name?: string;
  message!: Message;
}

